;(function($){

    function OpenNew() {
        
        $(document).on('click', '.bt-open', function(e){
            var event = e.preventDefault();

            var target = $(this).attr('data-target');
            
            $(target+' .box-open').addClass('open');

            $(target+' .box-open .degrade').css('height', '1px');

            $(target+' .open-new').css('display', 'none');
        });   

    }

   	new OpenNew();

}(jQuery));